import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { spacing } from "~/styles/theme";
import type { Space } from "./types";

export function Stack({
  children,
  gap = "md",
}: {
  children: ReactNode;
  gap?: Space;
}) {
  return <View style={stylesByGap[gap]}>{children}</View>;
}

const stylesheet = StyleSheet.create({
  xs: { gap: spacing.xs },
  sm: { gap: spacing.s },
  md: { gap: spacing.m },
  lg: { gap: spacing.l },
});

const stylesByGap = {
  xs: stylesheet.xs,
  sm: stylesheet.sm,
  md: stylesheet.md,
  lg: stylesheet.lg,
};
